import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8fc456c&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=b8fc456c&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=b8fc456c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc456c",
  null
  
)

export default component.exports